export const LOAD_SETTING_RECORDS = 'LOAD_SETTING_RECORDS';
export const SETTINGS_FORM_SUBMITTED_SUCCESS =
  'SETTINGS_FORM_SUBMITTED_SUCCESS';
export const SET_EDITING_SETTING = 'SET_EDITING_SETTING';
